import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalCaptureError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalCaptureError';
  }
}
